import { useI18nContext } from './I18nProvider';
import { SUPPORTED_UI_LANGUAGES } from './languages';

/**
 * Hook for building a language switcher. Returns the active `language`, the
 * `setLanguage(code)` callback wired up by the mounted {@link I18nProvider}
 * (or a no-op when none is mounted), and the {@link SUPPORTED_UI_LANGUAGES}
 * registry so callers can render one option per locale without re-importing
 * the constant.
 *
 * Calling `setLanguage` invokes whatever persistence the provider chose;
 * the caller does not need to update local state separately.
 *
 * @example
 *   const { language, setLanguage, languages } = useUiLanguage();
 *   languages.map((l) => (
 *     <button key={l.code} onClick={() => setLanguage(l.code)}>
 *       {l.nativeLabel}{l.code === language ? ' ✓' : ''}
 *     </button>
 *   ));
 */
export function useUiLanguage() {
  const { language, setLanguage } = useI18nContext();
  return {
    language,
    setLanguage,
    languages: SUPPORTED_UI_LANGUAGES,
  };
}
